/**
 * Construye la URL de la miniatura `hqdefault` de un vídeo de YouTube a
 * partir de su `videoId`. `hqdefault` es el nivel de calidad que YouTube
 * garantiza para prácticamente cualquier vídeo público (a diferencia de
 * `maxresdefault`, que solo existe para vídeos subidos en alta resolución) —
 * ver `specs/040-video-module/research.md` §5.
 */
export function getYouTubeThumbnailUrl(videoId: string): string {
  return `https://i.ytimg.com/vi/${videoId}/hqdefault.jpg`
}
